import Vue from 'vue'

export const uiBus = new Vue()

export function showModal(options = {}) {
  uiBus.$emit('ui-modal', { ...options, visible: true })
}

export function hideModal() {
  uiBus.$emit('ui-hide-modal')
}

export function showToast(payload, type = '', duration = 2000) {
  const toast = typeof payload === 'object' && payload !== null
    ? payload
    : { message: payload, type, duration }
  uiBus.$emit('ui-toast', {
    message: toast.message || '',
    type: toast.type || '',
    duration: toast.duration || duration
  })
}

export function showLoading(message = '加载中...') {
  uiBus.$emit('ui-loading', { text: message })
}

export function hideLoading() {
  uiBus.$emit('ui-hide-loading')
}

export function alert(message, title = '提示', okText = '知道了') {
  return new Promise(resolve => {
    uiBus.$emit('ui-modal', {
      visible: true,
      title,
      content: message,
      loading: false,
      showCancel: false,
      showFooter: true,
      okText,
      cancelText: '',
      onOk: () => resolve(true)
    })
  })
}

export function confirm(message, title = '确认', okText = '确定', cancelText = '取消') {
  return new Promise(resolve => {
    uiBus.$emit('ui-modal', {
      visible: true,
      title,
      content: message,
      loading: false,
      showCancel: true,
      showFooter: true,
      okText,
      cancelText,
      onOk: () => resolve(true),
      onCancel: () => resolve(false)
    })
  })
}
